import { FaWhatsapp } from "react-icons/fa";
import WhatsAppContactPicker from "./WhatsAppContactPicker";

export default function WhatsappFloatButton() {
    return (
        <WhatsAppContactPicker
            title="Fale com nossa equipe"
            subtitle="Escolha Gabriel ou Robson para abrir o WhatsApp."
            triggerClassName="fixed z-50 bottom-6 right-6 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg p-4 flex items-center justify-center transition-all"
            ariaLabel="Abrir opções de WhatsApp"
        >
            <FaWhatsapp className="text-3xl" />
        </WhatsAppContactPicker>
    );
}
